module.exports = "/images/vendor/flag-icon-css/flags/1x1/ar.svg?78827b0be4fd4c4f4fb458b2501309d1";